// @flow
import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import actionTypes from 'store/openStats/actionTypes';
import api from 'store/api';
import { URL } from '../../../constants/url';
import { getOpenStatsAction } from '../actions';

type Action = {
  type: actionTypes.GET_OPEN_STATS,
  payload: {
    ts: string,
    bb: string,
    stake: string,
  }
}

export function* getOpenStats({ payload }: Action) {
  try {
    const res = yield call(api, {
      method: 'post',
      url: URL.OPEN_STATS,
      data: {
        ts: payload.limit.value,
        bb: payload.stackSize.value,
        stake: payload.position.replace('  ', ''),
      },
    });

    yield put(getOpenStatsAction.success({
      open_stats: res.data,
    }));
  } catch (e) {
    yield put(getOpenStatsAction.error(e.response));
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_OPEN_STATS, getOpenStats);
}
